import { useState } from 'react';
import { FiLogOut } from 'react-icons/fi';

interface VerificationLogoutButtonProps {
  onLogout: () => void;
  /** Bloqueia o logout enquanto um POST de verificação está em andamento. */
  disabled?: boolean;
}

/**
 * Botão "Sair" das modais bloqueantes de verificação (email, telefone, 2FA).
 *
 * As modais de verificação não têm dismiss por design — sem este botão, um
 * usuário que não consegue confirmar o código no momento fica preso, sem poder
 * deslogar para entrar em outra conta. O clique executa o logout() do
 * AuthContext (que preserva localStorage['deviceId'] — CLAUDE.md NUNCA #37).
 *
 * Requer `position: relative` no card pai (posicionamento absoluto no canto
 * superior direito, onde ficaria um botão X de fechar).
 */
export function VerificationLogoutButton({ onLogout, disabled }: VerificationLogoutButtonProps) {
  const [hovered, setHovered] = useState(false);
  const active = hovered && !disabled;
  return (
    <button
      type="button"
      onClick={onLogout}
      disabled={disabled}
      data-testid="verification-logout"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        position: 'absolute',
        top: '12px',
        right: '12px',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '5px',
        padding: '6px 8px',
        fontSize: '13px',
        fontWeight: 500,
        color: active ? '#1e293b' : '#6b7280',
        backgroundColor: active ? '#f1f5f9' : 'transparent',
        border: 'none',
        borderRadius: '6px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
      }}
    >
      <FiLogOut style={{ width: '14px', height: '14px' }} />
      Sair
    </button>
  );
}
